import React from 'react';
import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../utils/formatDate';
import type { CurrentSubscription } from '../../types';

interface ScheduledChangeBannerProps {
  subscription: CurrentSubscription;
  onResume: () => void;
}

export const ScheduledChangeBanner: React.FC<ScheduledChangeBannerProps> = ({
  subscription,
  onResume,
}) => {
  const { t, i18n } = useTranslation();
  const scheduledChange = subscription.scheduledChange;

  if (!scheduledChange) {
    return null;
  }

  const currentName = subscription.package?.name ?? t('subscription.plan.currentGeneric');

  return (
    <Alert
      severity="warning"
      className="mb-6"
      action={
        scheduledChange.reason === 'trial_end' ? undefined : (
          <Button color="inherit" size="small" onClick={onResume} className="normal-case">
            {t('subscription.scheduledBanner.keep', { name: currentName })}
          </Button>
        )
      }
    >
      {t('subscription.scheduledBanner.message', {
        current: currentName,
        date: formatDate(scheduledChange.effectiveAt, i18n.language),
        target: scheduledChange.packageName,
      })}
    </Alert>
  );
};
